/* unplugin-vue-components disabled */import { render } from "./MenuBottom.vue?vue&type=template&id=e0c2c8da&scoped=true&ts=true"
import script from "./MenuBottom.vue?vue&type=script&lang=ts"
export * from "./MenuBottom.vue?vue&type=script&lang=ts"

import "./MenuBottom.vue?vue&type=style&index=0&id=e0c2c8da&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c2c8da"]])

export default __exports__